import * as React from "react";

export const Asterisk: React.FC = () => {
    return <span className="asterisk">*</span>
}